$(document).ready(function () {
  /*
   * Main Variant Selector on the PDP
   */
  const initProductCustomSelect = () => {
    const $mainSelect = $("select.single-option-selector");
    const $dummySelect = $("select.js-custom-select");
    const $dummySelectOptions = $dummySelect.find("option");
    const selectInstance = NiceSelect.bind(document.querySelector(".js-custom-select"));
    const $customSelect = $(".nice-select.js-custom-select");
    const $customSelectOption = $customSelect.find(".option");
    const giftProduct = document.querySelector(".js-product-gift");

    // Refresh Hidden Custom Select value
    $mainSelect.on("change", (event) => {
      if (giftProduct) {
        const mattressWidth = +$mainSelect.val().split("/")[0];

        if (mattressWidth <= 120) {
          giftProduct.querySelector("span").classList.add("is-hidden");
        } else {
          giftProduct.querySelector("span").classList.remove("is-hidden");
        }
      }

      const selectedOption = $dummySelect.find(`option[data-title="${$mainSelect.val()}"]`);
      const selectedOptionValue = selectedOption.val();
      $dummySelect.val(selectedOptionValue);
      const selectedOptionPrice = selectedOption.data("unformatted-price");
      const initTbi = document.querySelector(".js-init-tbi");

      const variantBundleDescription = selectedOption.data("variant-description");
      const bundleDescription = document.querySelector(".js-bundle-description");

      if (bundleDescription) {
        bundleDescription.innerHTML = variantBundleDescription;
      }

      if (initTbi) {
        initTbi.dataset.price = selectedOptionPrice;

        if (selectedOptionPrice < 10000) {
          initTbi.classList.add("is-hidden");
        } else {
          initTbi.classList.remove("is-hidden");
        }
      }
    });

    // Refresh Main Select value
    // Add data-price to the Custom Select Placeholder
    $customSelectOption.on("click", (event) => {
      const $target = $(event.target);
      const price = $target.data("price");
      const original_price = $target.data("original-price");
      const value = $target.text();

      // Add data-price to the Custom Select Placeholder
      $customSelect.find(".current").attr("data-price", price);
      original_price ? $(".price .money").text(original_price) : "";
      original_price ? $(".compare-at-price").text(price) : "";

      // Refresh Main Select value
      $mainSelect.val(value);
      $mainSelect.change();
    });

    // Initial Load Changes
    // Add Data Price to Custom Select options
    $dummySelectOptions.each(function (index) {
      const $this = $(this);
      $customSelect.find(`.option:nth-child(${index + 1})`).attr("data-price", $this.data("price"));
      $this.data("original-price")
        ? $customSelect
            .find(`.option:nth-child(${index + 1})`)
            .attr("data-original-price", $this.data("original-price"))
        : "";
    });

    // Select Variant from page URL Parameter
    const variantFromUrlTitle = $dummySelect.find(`option[value="${getParameterByName("variant")}"]`).data("title");

    if (variantFromUrlTitle) {
      $mainSelect.val(variantFromUrlTitle);
      $mainSelect.change();
    }

    // Show Product SKU
    $(".js-product-sku").removeClass("sku--loading");

    // Select the right value in the Custom select
    $customSelect.find(`.option[data-value="${$dummySelect.val()}"]`).click();
    // Remove class 'open' because the click() event toggles the dropdown
    $customSelect.removeClass("open");
  };

  // Get URL Parameter value
  const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  setTimeout(() => {
    initProductCustomSelect();
  }, 200);
});
